import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        rootAbsolute: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: theme.palette.common.white,
            zIndex: 100,
        },
        rootInline: {
            display: 'flex',
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
        },
        transparent: {
            background: theme.palette.primary.main,
            color: '#fff',
        },
    })
);

interface Props {
    variant?: 'absolute' | 'inline';
    size?: string | number | undefined;
    transparent?: boolean;
}

export default function Spin({ variant = 'absolute', size = 40, transparent }: Props) {
    const classes = useStyles();
    const spinSize = size ? size : 40;

    return (
        <div
            className={classNames(
                { [`${classes.rootAbsolute}`]: variant === 'absolute' },
                { [`${classes.rootInline}`]: variant === 'inline' },
                { [`${classes.transparent}`]: transparent }
            )}
        >
            <CircularProgress size={spinSize} color="inherit" />
        </div>
    );
}
